const scrollToTopStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  bottom: 35,
  background: ' rgba(90, 92, 105, 0.5)',
  width: '52px',
  height: '52px',
  padding: '8px',
  borderRadius: '50%',
};

export default scrollToTopStyle;
